import { EXPLICIT_DATA_TYPE_TO_FAMILY, KEYWORD_TO_DATA_TYPE_FAMILY } from '../../../constants/recommendations/DataTypeFamilies';
export const getDataTypeFamiliesByKeyword = dataTypeName => {
  const dataTypeFamilyMatches = Object.entries(KEYWORD_TO_DATA_TYPE_FAMILY).reduce((acc, [keyword, dataTypeFamilies]) => {
    if (dataTypeName.toLowerCase().includes(keyword)) {
      return dataTypeFamilies.concat(acc);
    }
    return acc;
  }, []);
  return Array.from(new Set(dataTypeFamilyMatches));
};
export const getDataTypeFamiliesForDataSource = dataSource => {
  const explicitFamilies = EXPLICIT_DATA_TYPE_TO_FAMILY[dataSource];
  if (explicitFamilies) {
    return explicitFamilies;
  }
  const isEvent = dataSource === null || dataSource === void 0 ? void 0 : dataSource.startsWith('e_');
  const keywordFamilies = isEvent ? getDataTypeFamiliesByKeyword(dataSource) : [];
  return keywordFamilies.length ? Array.from(new Set(keywordFamilies)) : [dataSource];
};